import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=e9ce0792&scoped=true&"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeMessage.vue?vue&type=style&index=0&id=e9ce0792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ce0792",
  null
  
)

export default component.exports